import React, { useRef, useState } from "react";
import {
    AiOutlineMail,
    AiOutlinePushpin,
    AiOutlineWhatsApp,
    AiOutlineFacebook,
    AiOutlineInstagram,
    AiOutlineYoutube,
} from "react-icons/ai";

import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

function Contact() {
    const form = useRef();
    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [msg, setMsg] = useState();

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                "service_tqtl74e",
                "template_5bhxtv6",
                form.current,
                "S0sXICIMYby-aU21K"
            )
            .then(
                (result) => {
                    console.log(result.text);
                },
                (error) => {
                    console.log(error.text);
                }
            );
        setEmail("");
        setMsg("");
        setName("");
        toast.success("Hi " + name + " Pesan Anda Berhasil Terikirim");
    };

    return (
        <>
            <section className="section bg-light" id="contact">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-heading mb-5">
                                <h3 className="text-dark mb-1 fw-light text-uppercase">
                                    Contact US
                                </h3>
                                <div className="title-border-simple position-relative"></div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="contact-box p-5">
                                <div className="row">
                                    <div className="col-md-6 col-lg-8">
                                        <form
                                            ref={form}
                                            onSubmit={handleSubmit}
                                        >
                                            <div className="custom-form p-3">
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="mb-3 input-label">
                                                            <input
                                                                name="name"
                                                                id="name"
                                                                placeholder="Name"
                                                                type="text"
                                                                className="form-control form-control"
                                                                value={
                                                                    name || ""
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    setName(
                                                                        e.target
                                                                            .value
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="mb-3 input-label">
                                                            <input
                                                                name="email"
                                                                id="email"
                                                                placeholder="email"
                                                                type="text"
                                                                className="form-control form-control"
                                                                value={
                                                                    email || ""
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    setEmail(
                                                                        e.target
                                                                            .value
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="mb-3 input-label">
                                                            <textarea
                                                                name="comments"
                                                                id="comments"
                                                                rows="5"
                                                                className="form-control"
                                                                placeholder="Message"
                                                                value={
                                                                    msg || ""
                                                                }
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    setMsg(
                                                                        e.target
                                                                            .value
                                                                    );
                                                                }}
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <input
                                                            type="submit"
                                                            id="submit"
                                                            name="send"
                                                            className="submitBnt btn btn-custom"
                                                            value="Send Message"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="col-md-6 col-lg-4">
                                        <div className="contact-cantent p-3">
                                            <div className="contact-details d-flex">
                                                <div className="float-start contact-icon me-3 mt-2">
                                                    <AiOutlineWhatsApp className="text-muted h5" />
                                                </div>
                                                <div className="app-contact-desc text-muted pt-1">
                                                    <p className="mb-0 info-title f-13">
                                                        Call :
                                                    </p>
                                                    <p className="mb-0 f-13">
                                                        0865-9758-8236
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="contact-details d-flex mt-2">
                                                <div className="float-start contact-icon me-3 mt-2">
                                                    <AiOutlineMail className="text-muted h5" />
                                                </div>
                                                <div className="app-contact-desc text-muted pt-1">
                                                    <p className="mb-0 info-title f-13">
                                                        Email :
                                                    </p>
                                                    <p className="mb-0 f-13">
                                                        <a
                                                            className="text-muted"
                                                            href="#/"
                                                        >
                                                            manggalapustaka@gmail.com
                                                        </a>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="contact-details d-flex mt-2">
                                                <div className="float-start contact-icon me-3 mt-2">
                                                    <AiOutlinePushpin className="text-muted h5" />
                                                </div>
                                                <div className="app-contact-desc text-muted pt-1">
                                                    <p className="mb-0 info-title f-13">
                                                        Location :
                                                    </p>
                                                    <p className="mb-0 f-13">
                                                        <a
                                                            className="text-muted"
                                                            href="#/"
                                                        >
                                                            Manggal RT 17, RW
                                                            06, Simo, Boyolali,
                                                            Jawa Tengah
                                                        </a>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="follow mt-4">
                                                <h4 className="text-dark mb-3">
                                                    Follow
                                                </h4>
                                                <ul className="follow-icon list-inline mt-32 mb-0">
                                                    <li className="list-inline-item f-15">
                                                        <a
                                                            href="https://web.facebook.com/profile.php?id=100076998842478"
                                                            className="social-icon text-muted"
                                                        >
                                                            <AiOutlineFacebook className="icon-href" />
                                                        </a>
                                                    </li>
                                                    <li className="list-inline-item f-15">
                                                        <a
                                                            href="https://www.instagram.com/manggalapustaka/"
                                                            className="social-icon text-muted"
                                                        >
                                                            <AiOutlineInstagram className="icon-href" />
                                                        </a>
                                                    </li>
                                                    <li className="list-inline-item f-15">
                                                        <a
                                                            href="#/"
                                                            className="social-icon text-muted"
                                                        >
                                                            <AiOutlineYoutube className="icon-href" />
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Contact;
